import IService from '../IService';

/**
 * @namespace app.api.beats
 */
export default IService.extend({
  check(asset) {
    return new Promise((resolve, reject) => {
      const BGMusicSourceId = asset.metadata.assetUUID;
      $.ajax({
        url: app.apiUrl(`/api/v1/beatDetection/BG_MUSIC/${BGMusicSourceId}`),
        type: 'GET',

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        dataType: 'json',
        success: (res) => {
          resolve(res);
        },
      });
    });
  },
  create(asset) {
    const data = {
      beatDetectionSource: 'BG_MUSIC',
      beatDetectionSourceId: asset.metadata.assetUUID,
    };
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.apiUrl('/api/v1/beatDetection'),
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(data),

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        dataType: 'json',
        success: (res) => {
          resolve(res);
        },
      });
    });
  },
});
